// src/app/auth/auth.guard.service.ts
import { Injectable } from '@angular/core';
import { Cookie } from 'ng2-cookies';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from './auth.service';
import { HttpParams, HttpHeaders, HttpClient } from '@angular/common/http';
import { Globals } from '../globals';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private router: Router,  public auth: AuthenticationService, private globals: Globals, public http: HttpClient) { }

    /**
    * Check on each request to ensure our refresh and access token are valid and updated
    * If the user leaves the application to rest for too long they will automatically have their session invalidated
    */
    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if(this.globals.clientId === undefined || this.globals.clientId === null) {
            const url = this.auth.getResourceURL() + "/api/v1/login/clientId";

            // Set request headers
            const requestHeaders = new HttpHeaders()
                .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8');

            // get request
            await this.http.get(url, {headers: requestHeaders, responseType: 'json' }).subscribe(
                data => {
                    this.auth.setClientId(data);
                    if(this.auth.isTokenValid()){
                        this.auth.setDataFromCookie();
                        this.router.navigate([state.url]);
                        return true;
                    } else {
                        this.auth.logout();
                        return false;
                    }
                },
                error => {
                    this.auth.logout();
                    console.log(error)
                }
            );
        } else {
            if(this.auth.isTokenValid()){
                return true;
            } else {
                this.auth.logout();
                return false;
            }

        }
    }

    /**
     * Used for ngIf in order to validate if user has logged in
     */
    canAccess() {
        if (this.auth.getAccessToken()) {
            return true;
        }
        return false;
    }

}
